var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.429,
    height: 18,
    viewBox: "0 0 15.429 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report-data",
    transform: "translate(-5.625 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3787",
    "data-name": "Path 3787",
    d: "M16.875,22.5h1.4v3.111h-1.4Z",
    transform: "translate(-4.237 -7.932)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3788",
    "data-name": "Path 3788",
    d: "M22.5,20.25h1.4v4.666H22.5Z",
    transform: "translate(-6.356 -7.237)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3789",
    "data-name": "Path 3789",
    d: "M11.25,15.75h1.4v7.776h-1.4Z",
    transform: "translate(-2.119 -5.848)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3790",
    "data-name": "Path 3790",
    d: "M19.651,4.179h-2.1V3.536a1.348,1.348,0,0,0-1.4-1.286h-5.61a1.348,1.348,0,0,0-1.4,1.286v.643h-2.1a1.348,1.348,0,0,0-1.4,1.286v13.5a1.348,1.348,0,0,0,1.4,1.286H19.651a1.348,1.348,0,0,0,1.4-1.286V5.464A1.348,1.348,0,0,0,19.651,4.179Zm-9.117-.643h5.61V6.107h-5.61Zm9.117,15.429H7.028V5.464h2.1V7.393h8.416V5.464h2.1Z",
    fill: "#74613c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportData);
export default __webpack_public_path__ + "static/media/report-data.12dfdfb8a2838a3c8f28c4c3bf290a75.svg";
export { ForwardRef as ReactComponent };